/**
 * @enum
 */
export const planViewEnum = {
  /** @name 塔吊 */
  towerCrane: 'TOWER_CRANE',
  /** @name 其他 */
  other: 'OTHER',
};
